import React from "react";

const sampleClients = [
  { name: "GS Battery", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/gs_battery.jpg?updatedAt=1759295406843" },
  { name: "CRP Group", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/crp_group.png?updatedAt=1759295406585" },
  { name: "HamiltonJet", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/HamiltonJet.jpg?updatedAt=1759295406583" },
  { name: "Chiyaboon", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/chaiyaboon.png?updatedAt=1759295406531" },
  { name: "L&T Defence", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/L%20&%20T%20Defence.jpg?updatedAt=1759295406509" },
  { name: "Vandewiele Savio", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/vandewiele_savio.jpg?updatedAt=1759295405536" },
  { name: "Dreem", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/dreem.jpg?updatedAt=1759295405197" },
  { name: "Varley", logo: "https://ik.imagekit.io/satfy9rkc/ptkcs/varley_indonesia_logo.jpg" },
  { name: "CMR", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/CMR.jpg?updatedAt=1759295406841" },
  { name: "SANDEN", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanden.png?updatedAt=1759295406829" },
  { name: "SANOH", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/sanoh.png?updatedAt=1759295406876" },
  { name: "AWAL GULF", logo: "https://ik.imagekit.io/kqumni8l2/Clients/Folder1/awal_gulf.jpg?updatedAt=1759295406865" },
];

export default function Clients() {
  return (
    <section 
      className="w-full py-16 md:py-20 px-4 sm:px-8"
      style={{ backgroundColor: "#ffffff" }}
    >
      {/* Centered Heading and Paragraph */}
      {/* <div className="max-w-[1280px] mx-auto text-center mb-12">
        <h2 
          className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight mb-3"
          style={{ color: "#1A2634" }}
        >
          Leading Clients Worldwide
        </h2>
        <p 
          className="text-lg max-w-4xl mx-auto text-center"
          style={{ color: "#6B7280" }}
        >
          Behind every great transformation — a trusted client partnership.
        </p>
      </div> */}

      {/* Grid Layout with Light Border Cards */}
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 justify-items-center items-center">
          {sampleClients.map((client) => (
            <LogoCard key={client.name} client={client} />
          ))}
        </div>
      </div>
    </section>
  );
}

function LogoCard({ client }) {
  const [imageError, setImageError] = React.useState(false);

  const handleMouseEnter = (e) => {
    e.currentTarget.style.filter = "grayscale(0%)";
    e.currentTarget.style.transform = "scale(1.06)";
    e.currentTarget.style.boxShadow = "0 12px 32px rgba(26,38,52,0.12)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.filter = "grayscale(20%)";
    e.currentTarget.style.transform = "scale(1)";
    e.currentTarget.style.boxShadow = "none";
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div
      className="flex items-center justify-center transition-all duration-300 cursor-pointer bg-white rounded-lg"
      style={{ 
        width: "160px", 
        height: "88px", 
        filter: "grayscale(20%)", 
        transform: "scale(1)",
        border: "1px solid #E5E7EB",
        boxShadow: "none",
      }}
      title={client.name}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!imageError ? (
        <img
          src={client.logo}
          alt={client.name}
          className="max-w-[130px] max-h-[64px] w-auto h-auto object-contain transition-all duration-300"
          onError={handleImageError}
        />
      ) : (
        <span 
          className="text-xs font-semibold text-center px-2 transition-all duration-300"
          style={{ color: "#1A2634" }}
        >
          {client.name}
        </span>
      )}
    </div>
  );
}